/** Convert the existing CRM Personal Details shape to the staff booking contract. */
export function staffBookingPatient(details = {}) {
  const dob = details.date_of_birth || details.dob;
  const dateOfBirth = typeof dob === 'string' ? dob.replace(/^(\d{2})-(\d{2})-(\d{4})$/, '$3-$2-$1') : undefined;
  return {
    first_name: (details.first_name || details.firstName || '').trim(),
    last_name: (details.last_name || details.lastName || '').trim(),
    email: (details.lead_contact?.email || details.email || '').trim(),
    phone: (details.lead_contact?.phone || details.phoneNumber || details.phone || '').trim(),
    ...(dateOfBirth ? { date_of_birth: dateOfBirth } : {}),
    postcode: details.lead_address?.postcode || details.postcode || '',
    booked_on_behalf: !!details.booked_on_behalf,
    guardian_name: details.guardian_name || '',
    guardian_relation: details.guardian_relation || '',
    guardian_email: details.guardian_email || '',
    guardian_phone: details.guardian_phone || '',
  };
}

export function staffPatientIsMinor(dateOfBirth, today = new Date()) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth || '')) return false;
  const [year, month, day] = dateOfBirth.split('-').map(Number);
  let age = today.getFullYear() - year;
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age -= 1;
  return age < 16;
}
